import { useAuthStore } from '@/store/auth.store';
import { AppModule } from '../constants/modules';
import { canReadModule, canWriteModule } from '../utils/permissions';

export const usePermissions = () => {
  const user = useAuthStore(s => s.user);

  const isAdmin = user?.role === 'ADMIN';

  const canRead = (module: AppModule): boolean => {
    if (!user) {
      return false;
    }
    if (isAdmin) {
      return true;
    }
    return canReadModule(user, module);
  };

  const canWrite = (module: AppModule): boolean => {
    if (!user) {
      return false;
    }
    if (isAdmin) {
      return true;
    }
    return canWriteModule(user, module);
  };

  return {
    user,
    isAdmin,
    canRead,
    canWrite,
  };
};
